import { usePaginatedApi } from "../../../swr/useApi";
import { adminLoyaltyService } from "../../api_client";
import type { LoyaltyRedemptionDto } from "../../../api";
import type { AxiosResponse } from "axios";
import type { PaginatedResponse } from "../../pagination/data/types/pagination";

// `AdminLoyaltyRedemptionDto` (= LoyaltyRedemptionDto + nested `user`) appears
// on the generated client after `npm run generate:api`. Aliased locally —
// also extends LoyaltyRedemptionDto with the new `saleOrderId` and
// `isReversed` fields that show up post-regen, so call sites can read them
// today without further casts.
export interface AdminLoyaltyRedemptionDto extends Omit<LoyaltyRedemptionDto, 'isReversed'> {
    saleOrderId?: number | null;
    isReversed?: boolean;
    user: {
        id: string;
        name: string;
        email?: string | null;
        phoneNumber?: string | null;
        companyName?: string | null;
    };
}

interface RedemptionsQuery {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    isReversed?: boolean;
}

/**
 * Admin: paginated redemptions across all users, including the linked
 * sale.order id and basic user info. The `getAllRedemptions` method appears
 * on the generated client after `npm run generate:api`.
 */
export function useAdminLoyaltyRedemptions(query?: RedemptionsQuery) {
    return usePaginatedApi<AdminLoyaltyRedemptionDto, RedemptionsQuery>({
        key: "admin-loyalty-redemptions",
        serviceMethod: async (queryParams) => {
            const svc = adminLoyaltyService as unknown as {
                getAllRedemptions: (
                    q?: RedemptionsQuery,
                ) => Promise<
                    AxiosResponse<PaginatedResponse<AdminLoyaltyRedemptionDto>>
                >;
            };
            return await svc.getAllRedemptions(queryParams);
        },
        query: query,
    });
}
